import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useFormik } from "formik";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";
import buttonStyles from "../../../../styles/Button.module.css";
import styles from "./../tooltip.module.css";

import ChangeCreditLimitModal from "../LimitLevels/ChangeCreditLimitModal";
import ChangeLevelModal from "../LimitLevels/ChangeLevelModal";
//import SearchBar from "../SearchBar";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import { buildNameWithId, onlyNumbers, Singleton } from "helper/tools";
import { format } from "date-fns";
import { MdOutlineFileDownload } from "react-icons/md";
import ExportCSV from "../ExportCSV";
import invalidClass, { handleStatus } from "../../helperFunctions/helpers";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import CreatePago, { PagoModalMode } from "../Clientes/CreatePago";
import LoadingButton from "../LoadingButton/LoadingButton";
import PagosModal from "./PagosModal";
import ProrrateoModal from "./ProrrateoModal";
import { CurrencyInput } from "components/CurrencyInput";
import CreateConvenio from "../Clientes/CreateConvenio";
import CobranzaReestructuraTable from "./CobranzaReestructuraTable";

export default function CobranzaReestructura() {
  const createAbonoRef = useRef();

  const createAsociadosRef = useRef();
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();

  const refAutocompleteAsociados = useRef(null);

  const csvRef = useRef();

  const createPagoRef = useRef();
  const createConvenioRef = useRef();
  const verPagosRef = useRef();
  const verProrrateosRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [modalConvenioData, setModalConvenioData] = useState(null);
  const [modalPagoData, setModalPagoData] = useState(null);
  const [modalPagosData, setModalPagosData] = useState(null);
  const [modalProrrateosModalData, setModalProrrateosModalData] =
    useState(null);

  const [pagosData, setPagosData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [asociados, setAsociados] = useState([]);

  const [isHeaderLoading, setIsHeaderLoading] = useState(false);

  const [isFormaPagoLoading, setIsFormaPagoLoading] = useState(false);

  const [formasDePago, setFormasDePago] = useState([]);

  const [formaDePagoSelected, setFormaDePagoSelected] = useState(0);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);
  const [lastParcialInfo, setLastParcialInfo] = useState(null);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const [errorsAsociadoId, setErrorsAsociadoId] = useState();
  const [asociadoId, setAsociadoId] = useState(0);

  const clearCobranza = {
    saldoAlCorte: 0,
    comisionTotal: 0,
    comisionFinal: 0,
    totalAPagar: 0,
    /*abonado: 0,
    disponible: 0,
    pagosCount: 0,*/
  };

  const clearCobranzaDetail = {
    abonado: 0,
    disponible: 0,
    pagosCount: 0,
  };

  const [cobranzaInfo, setCobranzaInfo] = useState({
    ...clearCobranza,
  });

  const [cobranzaInfoDetail, setCobranzaInfoDetail] = useState({
    ...clearCobranzaDetail,
  });

  let initialValues = {
    id: 0,
    entrante: 0,
  };

  useEffect(() => {
    console.log("--->");
    //configureDatePicker();

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    fetchAsociadoData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  useEffect(() => {
    fetchData();
  }, [asociadoId]);

  useEffect(() => {
    if (modalData == null) return;

    createPagoRef.current.toggleModal();
  }, [modalData]);

  /*  useEffect(() => {
    if (modalConvenioData == null) return;

    createConvenioRef.current.toggleModal();
  }, [modalConvenioData]);*/

  useEffect(() => {
    if (modalProrrateosModalData == null) return;

    verProrrateosRef.current.toggleModal();
  }, [modalProrrateosModalData]);

  function fetchData() {
    detailAsociadoItem(asociadoId);
    getDetailTotal(asociadoId);
  }

  const fetchAsociadoData = async () => {
    setIsFormaPagoLoading(true);

    const responseHistorialLast = await api
      .parcialidadHistorialLast()
      .catch((e) => {
        toast.error("Error al pedir info Ultimo Parcialidad.");
      });

    setLastParcialInfo(responseHistorialLast?.data);

    const responseMetodosPago = await api.getFormasDePago().catch((e) => {
      toast.error("Error al pedir Metodos Pago.");
    });

    setIsFormaPagoLoading(false);
    if (!responseMetodosPago) return;

    const autoMetodosPago = responseMetodosPago.data.map((item) => {
      //const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, name: item.nombre, info: item };
    });

    setFormasDePago([{ id: 0, name: "Seleccionar..." }, ...autoMetodosPago]);

    const response = await api
      .searchAsociados({ isActivo: true, page: 1, pageSize: "350" })
      .catch((e) => {
        toast.error("Error al pedir asociados.");
      });
    if (!response) return;

    const autoAsociados = response.data.subset.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);

    console.log(response.status);
  };

  function createAsociado(event) {
    console.log(event);
    loadItem({});
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    //createAsociadosRef.current.toggleModal();
    createAbonoRef.current.toggleModal();
  }

  function loadConvenioItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalConvenioData(item);

    //createAsociadosRef.current.toggleModal();
    createConvenioRef.current.toggleModal();
  }

  async function getDetailTotal(newAsociadoId, finishCallback) {
    if (newAsociadoId == null || newAsociadoId === 0) {
      // clear & return
      let cobranzaInfoNew = {
        ...clearCobranzaDetail,
      };
      setCobranzaInfoDetail(cobranzaInfoNew);
      return;
    }

    //const criteria = { asociadoId };
    setIsHeaderLoading(true);
    const response = await api.pagosByAsociadoId(asociadoId).catch((error) => {
      toast.error("Error al buscar Detalle de Asociado.");
      setIsHeaderLoading(false);
      finishCallback?.();
    });
    setIsHeaderLoading(false);
    if (!response) return;

    console.log("---");
    if (response.data.length === 0) {
      setCobranzaInfoDetail({ ...clearCobranzaDetail });

      setPagosData([]);
    } else {
      const data = response.data[0];

      setPagosData(data);
      //  kpiData[itemIndex].clientes = response.data.subset;

      //  const newKpiData = JSON.parse(JSON.stringify(kpiData));

      /*
    let saldoAlCorte = 0;
    let totalAPagar = 0;
    data.forEach((element) => {
      saldoAlCorte += element.pendienteTotalParcialidad;
      totalAPagar += element.total;
    });*/

      setFormaDePagoSelected(0);
      formik.setFieldValue("entrante", 0);

      let cobranzaInfoDetailNew = { ...cobranzaInfoDetail };
      cobranzaInfoDetailNew.abonado = data.total;
      cobranzaInfoDetailNew.disponible = data.totalPorAplicar;
      cobranzaInfoDetailNew.pagosCount = data.pagosCount;
      setCobranzaInfoDetail(cobranzaInfoDetailNew);
    }

    //  setKpiData(data);
    finishCallback?.();
  }

  async function detailAsociadoItem(newAsociadoId, finishCallback) {
    if (newAsociadoId == null || newAsociadoId === 0) {
      // clear & return
      let cobranzaInfoNew = {
        ...clearCobranza,
      };
      setCobranzaInfo(cobranzaInfoNew);
      setKpiData([]);
      return;
    }

    setIsLoading(true);
    const criteria = { asociadoId };
    const response = await api
      .asociadoCobranzaDetalle(criteria)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsLoading(false);
        finishCallback?.();
      });
    setIsLoading(false);

    if (!response) return;

    console.log("---");
    const data = response.data.subset;

    const other = response.data.other;
    //  kpiData[itemIndex].clientes = response.data.subset;

    //  const newKpiData = JSON.parse(JSON.stringify(kpiData));
    const dataAll = data.map((m) => {
      const clientId = m.cliente?.id ?? 0;
      const interestItems = other.filter((a) => a.clienteId === clientId);

      return {
        ...m,
        interestItems,
      };
    });

    let saldoAlCorte = 0;
    let totalAPagar = 0;
    dataAll.forEach((element) => {
      saldoAlCorte += element.ordenParcialidades.reduce(
        (accumulator, ordenParcialidad) => {
          //  return currentValue.pendienteTotalParcialidad;
          return (
            accumulator +
            ordenParcialidad.productoParcialidades.reduce(
              (accumulator, productoParcialidad) => {
                const parcialidadActual =
                  productoParcialidad.parcialidades.find(
                    (e) =>
                      e.parcialidadNumero ===
                      productoParcialidad.parcialidadNumero,
                  );
                if (parcialidadActual) {
                  return accumulator + parcialidadActual.totalPendiente;
                }
                return accumulator;
              },
              0,
            )
          );
        },
        0,
      );

      //interes
      saldoAlCorte += element.interestItems.reduce(
        (accumulator, interestItem) => {
          return accumulator + interestItem.totalPendiente;
        },
        0,
      );

      totalAPagar += element.total;
    });

    let cobranzaInfoNew = { ...cobranzaInfo };
    cobranzaInfoNew.saldoAlCorte = saldoAlCorte;
    cobranzaInfoNew.totalAPagar = totalAPagar;
    setCobranzaInfo(cobranzaInfoNew);

    setKpiData(dataAll);
    finishCallback?.();
  }

  /**
   * Search handler
   */
  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    const response = await api
      .searchCobranzaAsociados(criteria)
      .catch((error) => {
        toast.error("Error al buscar Clientes.");
        setIsLoading(false);
      });
    if (!response) return;

    setKpiData(response.data.subset);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados
    const pagosFechas = ["31/10/2025", "15/11/2025"];

    const csvString = [
      [
        "NumAsociado",
        "AsociadoNombre",
        "AsociadoApellido",
        "CreditoDisponible",
        "NumCliente",
        "ClienteNombre",
        "ClienteApellido",
        "OrdenId",
        "NumProducto",
        "ProductoNombre",
        "ProductoPrecio",
        "FechaEntrega",
        ...pagosFechas,
      ], // Specify your headers here
      ...kpiData.map((item) => {
        //--
        const numAsociado = item.asociado.numAsociado ?? "-";
        const nombreAsociado = item.asociado.nombre ?? "";
        const apellidoAsociado = item.asociado.apellidoPaterno ?? "";

        const totalPagar = Singleton.getInstance().format(item.total);
        const pendienteTotalParcialidad = Singleton.getInstance().format(
          item.pendienteTotalParcialidad,
        );

        const ordenParcialidades = item.ordenParcialidades;
        const parcialidadActual = ordenParcialidades.parcialidadActual;
        const parcialidadTotal = ordenParcialidades.totalParcialidades;
        const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

        const parcialidad = ordenParcialidades.parcialidades[parcialidadActual];
        const pagoRequerido = Singleton.getInstance().format(parcialidad.total);

        //const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
        const fechaInicial = format(parcialidad.fechaInicio, "dd-MMM-yyyy");
        const fechaFin = format(parcialidad.fechaFin, "dd-MMM-yyyy");
        //const fechaRango = `${fechaInicial} - ${fechaFin}`;
        const fechaRango = `${fechaInicial}`;

        //  const start = new Date();
        /*start.setMonth(monthIndex);
                                        start.setDate(1);*/
        //  const clientes = asociadosClientes[item.id] ?? [];
        const clientes = item.clientes;
        //------[
        const clientesMaps = clientes.map((item) => {
          const numCliente = item.cliente?.numCliente ?? "-";
          const nombreCliente = item.cliente?.nombre ?? "";
          const apellidoCliente = item.cliente?.apellidoPaterno ?? "";

          const orderId = "343"; //item.orderVenta.id;

          const totalPagar = Singleton.getInstance().format(item.total);

          const pendienteTotalParcialidad = Singleton.getInstance().format(
            item.pendienteTotalParcialidad,
          );

          const ordenParcialidades = item.ordenParcialidades;
          const parcialidadActual = ordenParcialidades.parcialidadActual;
          const parcialidadTotal = ordenParcialidades.totalParcialidades;
          const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

          const parcialidad =
            ordenParcialidades.parcialidades[parcialidadActual];
          const pagoRequerido = Singleton.getInstance().format(
            parcialidad.total,
          );

          const fechaInicial = format(parcialidad.fechaInicio, "dd-MMM-yyyy");
          const fechaFin = format(parcialidad.fechaFin, "dd-MMM-yyyy");
          const fechaRango = `${fechaInicial} - ${fechaFin}`;
          //const fechaRango = `${fechaInicial}`;

          return [
            "",
            "",
            "",
            "",
            numCliente,
            nombreCliente,
            apellidoCliente,
            orderId,
            totalPagar,
            pendienteTotalParcialidad,
            parcialidadActual,
            parcialidadTotal,
            numPago,
            pagoRequerido,
            fechaRango,
          ];
        });
        ///-------]

        //--
        //  const id = item.numProducto ?? "";

        return [
          [
            numAsociado,
            nombreAsociado,
            apellidoAsociado,
            "",
            "",
            "",
            totalPagar,
            "Credito",
            "numclient",
            item.nombre ?? "",
            item.marca?.nombre ?? "",
            item.genero?.nombre ?? "",
            item.tamaño?.nombre ?? "",
            item.concentracion?.nombre ?? "",
            handleStatus(item).text,
          ],
          ...clientesMaps,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "productosCatalogo.csv");
  }

  async function detailItem(itemIndex, finishCallback) {
    const criteria = { asociadoId: asociadoId };
    const response = await api
      .asociadoCobranzaDetalle(criteria)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsLoading(false);
        finishCallback();
      });
    if (!response) return;

    console.log("---");
    //const data = response.data.subset;
    kpiData[itemIndex].clientes = response.data.subset;

    const newKpiData = JSON.parse(JSON.stringify(kpiData));

    setKpiData(newKpiData);
    finishCallback();
  }

  async function abonarCliente(event, cobranzaItem) {
    /*  event,
    cobranzaItem,
    productoParcialidad,
    interestItem = null,
  ) {*/
    //function loadItem(item) {
    //  if (!permissions.canVerDetalle) return;

    /*
      event,
    cobranzaItem,
    productoParcialidad,
    interestItem = null,
  ) {
    //function loadItem(item) {
    //  if (!permissions.canVerDetalle) return;

    //console.log(createClientesRef);
    setModalPagoData({
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
    });

    createPagoRef.current.toggleModal();
    */

    //console.log(createClientesRef);
    const productoParcialidad = null;
    const interestItem = null;

    setModalPagoData({
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
      pagoModalMode: PagoModalMode.Cliente,
    });

    createPagoRef.current.toggleModal();

    return;

    doProrrateoCliente(cobranzaItem);
    /*  const ordenParcialidades = cobranzaItem.ordenParcialidades;
    const productoParcialidades = ordenParcialidades.flatMap(
      (e) => e.productoParcialidades,
    );

    const total = productoParcialidades.map((e) => {
      return e.total;
    });

    let cobranzaAll = { ...cobranzaInfoDetail };

    productoParcialidades.forEach(async (e) => {
      const parcialidad = e.parcialidades[e.parcialidadNumero - 1];
      //const porPagar = parcialidad.porPagar;
      const porPagar = parcialidad.total;

      //
      //  cobranzaAll.disponible

      let extraInfo = {};
      if (cobranzaItem.cliente) {
        extraInfo = { clienteId: cobranzaItem.cliente.id };
      } else if (cobranzaItem.cliente == null) {
        extraInfo = { clienteId: cobranzaItem.cliente.id };
      }

      const response = await api
        .createSubPago({
          pagoId: asociadoId,
          parcialidadId: formaDePagoSelected,
          Total: porPagar,
          ...extraInfo,
        })
        .catch((e) => {
          toast.error("Error al crear SubPago.");
        });
      if (!response) return;

      return porPagar;
    });

    //cobranzaInfoDetail

    console.log(". " + cobranzaAll.disponible);*/

    /*
                {productoParcialidades.map(
                                                  (productoParcialidad, index) => {
                                                    //const cliente = productoParcialidadCliente.cliente;
              
                                                    const ordenVentaDetalle =
                                                      productoParcialidad?.ordenVentaDetalle;
                                                    let nombreProducto =
                                                      ordenVentaDetalle?.producto?.nombre ??
                                                      "";
              
                                                    const ordenId =
                                                      ordenVentaDetalle.ordenVentaId ?? 0;
                                                    //-
                                                    let fechaVenta = format(
                                                      productoParcialidad.fechaInicio,
                                                      "dd-MMM-yyyy",
                                                    );
              
                                                    let precio =
                                                      Singleton.getInstance().format(
                                                        ordenVentaDetalle.precio,
                                                      );
              
                                                    let plazo =
                                                      productoParcialidad.parcialidades
                                                        .length;
              
                                                    let abono = 0;
              
                                                    productoParcialidad.parcialidades.some(
                                                    */
    console.log("");
  }

  async function createConvenios(event, cobranzaItem) {
    const productoParcialidad = null;
    const interestItem = null;

    setModalConvenioData({
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
    });

    createConvenioRef.current.toggleModal();
  }

  async function abonarProducto(
    event,
    cobranzaItem,
    productoParcialidad,
    interestItem = null,
  ) {
    //function loadItem(item) {
    //  if (!permissions.canVerDetalle) return;

    //console.log(createClientesRef);
    setModalPagoData({
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
    });

    //createPagoRef.current.toggleModal();
  }

  async function verPagos(event, cobranzaItem, productoParcialidad) {
    //function loadItem(item) {
    //  if (!permissions.canVerDetalle) return;

    //console.log(createClientesRef);
    setModalPagosData(pagosData);

    verPagosRef.current.toggleModal();
  }

  async function verProrrateosAnteriores(
    event,
    cobranzaItem,
    productoParcialidad,
  ) {
    //function loadItem(item) {
    //  if (!permissions.canVerDetalle) return;

    setIsHeaderLoading(true);
    const response = await api
      .distribucionPagosByAsociadoId(asociadoId)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsHeaderLoading(false);
        //  finishCallback?.();
      });
    setIsHeaderLoading(false);

    //console.log(createClientesRef);
    setModalProrrateosModalData(response.data);

    //  verProrrateosRef.current.toggleModal();
  }

  async function abonarProducto1(event, cobranzaItem, productoParcialidad) {
    /* const ordenParcialidades = cobranzaItem.ordenParcialidades;
    const productoParcialidades = ordenParcialidades.flatMap(
      (e) => e.productoParcialidades,
    );

    const total = productoParcialidades.map((e) => {
      return e.total;
    });

    const totalParcialidad = productoParcialidades.map((e) => {
      const parcialidad = e.parcialidades[e.parcialidadNumero - 1];
      const porPagar = parcialidad.porPagar;

      return porPagar;
    });*/

    const parcialidadActual = productoParcialidad.parcialidades.find(
      (e) => e.parcialidadNumero === productoParcialidad.parcialidadNumero,
    );
    if (parcialidadActual == null) {
      console.log("--> INVALID parcialidadNumero");
      return;
    }

    let cobranzaInfoDetailAll = { ...cobranzaInfoDetail }; //cobranzaInfoDetail

    console.log(". " + cobranzaInfoDetailAll.disponible);

    let subPagoValue = parcialidadActual.total;
    if (cobranzaInfoDetail.disponible < parcialidadActual.total) {
      subPagoValue = cobranzaInfoDetail.disponible;
    }

    let extraInfo = {};
    if (cobranzaItem.cliente) {
      extraInfo = { clienteId: cobranzaItem.cliente.id };
    } else if (cobranzaItem.cliente == null) {
      extraInfo = { clienteId: cobranzaItem.cliente.id };
    }

    const response = await api
      .createSubPago({
        pagoId: asociadoId,
        parcialidadId: parcialidadActual.id,
        Total: subPagoValue,
        ...extraInfo,
      })

      /*const response = await api
      .createSubPago({
        //  pagoId: asociadoId,
        parcialidadId: parcialidadActual.id,
        Total: subPagoValue,
      })*/
      .catch((e) => {
        toast.error("Error al hacer SubPago.");
      });
    if (!response) return;

    fetchData();

    /*
                {productoParcialidades.map(
                                                  (productoParcialidad, index) => {
                                                    //const cliente = productoParcialidadCliente.cliente;
              
                                                    const ordenVentaDetalle =
                                                      productoParcialidad?.ordenVentaDetalle;
                                                    let nombreProducto =
                                                      ordenVentaDetalle?.producto?.nombre ??
                                                      "";
              
                                                    const ordenId =
                                                      ordenVentaDetalle.ordenVentaId ?? 0;
                                                    //-
                                                    let fechaVenta = format(
                                                      productoParcialidad.fechaInicio,
                                                      "dd-MMM-yyyy",
                                                    );
              
                                                    let precio =
                                                      Singleton.getInstance().format(
                                                        ordenVentaDetalle.precio,
                                                      );
              
                                                    let plazo =
                                                      productoParcialidad.parcialidades
                                                        .length;
              
                                                    let abono = 0;
              
                                                    productoParcialidad.parcialidades.some(
                                                    */
    console.log("");
  }

  async function openEstadoCuenta(itemIndex, finishCallback) {
    if (isNaN(itemIndex) || itemIndex < 0) {
      if (finishCallback != null) finishCallback();
      return;
    }

    const item = kpiData[itemIndex];
    const asociadoId = item.asociado.id;

    const criteria = { asociadoId: asociadoId };
    const response = await api
      .asociadoCobranzaEstadoCuenta(criteria)
      .catch((error) => {
        toast.error("Error al buscar Detalle de Asociado.");
        setIsLoading(false);
        finishCallback?.();
      });
    if (!response) return;

    /// name file, fallback random
    const secondsSinceEpoch = Math.floor(Date.now() / 1000);
    let fileName = `Estado_Cuenta_${secondsSinceEpoch}.pdf`;

    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
      const fileNameMatch = contentDisposition
        .matchAll(/filename=(.*?)(;|$)/g)
        .toArray()[0][1];
      fileName = fileNameMatch.replace(/"/g, "");
      console.log("File Name:", fileName);
    }

    // 1. Create a URL for the Blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a temporary URL for the blob object
    //  const url = window.URL.createObjectURL(blob);

    // To Open in new tab:
    //  window.open(url);

    /*
    https://www.google.com/search?q=web+api+c%23+download+file+and+open&client=firefox-b-d&hs=WgQ&sca_esv=8eb5eb78efc6b1d8&sxsrf=ANbL-n6yfXnM9yY3j1foZcV3t3SaabxSbw%3A1776970046106&ei=PmnqaYubBrfwkPIPiaWB8AY&biw=1426&bih=834&ved=0ahUKEwiLsv-i0YSUAxU3OEQIHYlSAG4Q4dUDCBE&uact=5&oq=web+api+c%23+download+file+and+open&gs_lp=Egxnd3Mtd2l6LXNlcnAiIXdlYiBhcGkgYyMgZG93bmxvYWQgZmlsZSBhbmQgb3BlbjIFECEYoAFIio8BUL8FWJeIAXABeAGQAQCYAc4BoAGKEKoBBTguOS4xuAEDyAEA-AEBmAIToALzEcICChAAGLADGNYEGEfCAgQQIxgnwgIKECMYgAQYJxiKBcICERAuGIAEGLEDGNEDGIMBGMcBwgIIEAAYgAQYsQPCAgoQABiABBhDGIoFwgILEAAYgAQYsQMYgwHCAgsQLhiABBjRAxjHAcICEBAAGIAEGLEDGEMYgwEYigXCAggQLhiABBixA8ICDRAAGIAEGLEDGEMYigXCAgcQABiABBgKwgIWEC4YgAQYsQMY0QMYQxiDARjHARiKBcICBRAAGIAEwgIGEAAYChgewgIEEAAYHsICCRAAGIAEGAoYC8ICBxAjGLECGCfCAgYQABgWGB7CAggQABgWGAoYHsICBRAAGO8FwgIFECEYnwXCAgQQIRgVmAMA4gMFEgExIECIBgGQBgiSBwYyLjE2LjGgB8B0sgcGMS4xNi4xuAfaEcIHCTAuMy42LjguMsgHsgGACAA&sclient=gws-wiz-serp
    */

    // To Download:
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    console.log("---");

    //  kpiData[itemIndex].clientes = response.data.subset;

    //    const newKpiData = JSON.parse(JSON.stringify(kpiData));

    //  setKpiData(newKpiData);
    //  finishCallback();

    // 4. Free up memory
    window.URL.revokeObjectURL(url);
    //document.body.removeChild(a);
  }

  let cobranzaAll = { ...cobranzaInfo };
  cobranzaAll.saldoAlCorte = Singleton.getInstance().format(
    cobranzaAll.saldoAlCorte,
  );
  cobranzaAll.comisionTotal = Singleton.getInstance().format(
    cobranzaAll.comisionTotal,
  );
  cobranzaAll.comisionFinal = Singleton.getInstance().format(
    cobranzaAll.comisionFinal,
  );
  cobranzaAll.totalAPagar = Singleton.getInstance().format(
    cobranzaAll.totalAPagar,
  );

  let cobranzaInfoDetailAll = { ...cobranzaInfoDetail };
  cobranzaInfoDetailAll.abonado = Singleton.getInstance().format(
    cobranzaInfoDetailAll.abonado,
  );

  cobranzaInfoDetailAll.disponible = Singleton.getInstance().format(
    cobranzaInfoDetailAll.disponible,
  );

  const abonado = `${cobranzaInfoDetailAll.abonado} (${cobranzaInfoDetailAll.pagosCount} Pagos)`;

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      /*const payload = {
                        entrante: item.credito,
                      };*/

      const toastId = toast.loading("Actualizando Credito...");

      const creditoDisp = onlyNumbers(values.entrante);
      let response = await api
        .updateCreditoDispuestoAsociado("item.id", creditoDisp)
        .catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Actualizar Credito. ${e.mensaje}`);
            //  setIsLoading(false);
            return;
          }
          toast.error("Error al Actualizar Credito.");
          //  setIsLoading(false);
        });

      //    setIsLoading(false);
      toast.dismiss(toastId);

      if (!response) return;

      toast.success("Credito Actualizado.");
      //    reloadOrdenes();
      //if (reload) reload();

      //filtrosRef.current.click();
    },
  });

  async function saveAmount(event) {
    setIsLoading(true);
    const response = await api
      .createPago({
        asociadoId: asociadoId,
        FormaDePagoId: formaDePagoSelected,
        Total: formik.values.entrante,
      })
      .catch((e) => {
        toast.error("Error al crear Pago.");
      });
    setIsLoading(false);
    if (!response) return;

    formik.setFieldValue("entrante", 0);

    getDetailTotal(asociadoId);
  }

  function reloadCobranza() {
    fetchData();
  }

  function LabelLoading({ text, isLoading, moreClass = null, ...otherProps }) {
    if (isLoading)
      return (
        <>
          <div className="animate-pulse" style={{}}>
            <div
              style={{
                height: "21px",
                width: "55px",
              }}
            />
          </div>
        </>
      ); // Early return

    return (
      <>
        <label
          htmlFor="exampleFormControlInput1"
          className={`form-label ${moreClass}`}
          {...otherProps}
        >
          {text}
        </label>
      </>
    );
  }

  //---

  let pendienteActualAsociado = kpiData.reduce((accumulatorCliente, info) => {
    let ordenParcialidades = info.ordenParcialidades;

    ///--->
    let pendienteOrdenesActual = ordenParcialidades.reduce(
      (accumulatorOrden, ordenParcialidad) => {
        let pendienteActual = ordenParcialidad.productoParcialidades.reduce(
          (accumulator, productoParcialidad) => {
            ///
            let currentParcialidad = productoParcialidad?.parcialidades.find(
              (e) =>
                e.parcialidadNumero === productoParcialidad?.parcialidadNumero,
            );

            return accumulator + currentParcialidad.totalPendiente;
          },
          0,
        );

        return accumulatorOrden + pendienteActual;
      },
      0,
    );

    return accumulatorCliente + pendienteOrdenesActual;
  }, 0);

  let disableProrratear =
    pendienteActualAsociado > cobranzaInfoDetail?.disponible;

  if (pendienteActualAsociado === 0 || cobranzaInfoDetail?.disponible === 0)
    disableProrratear = true;

  //---

  /*const asyncTimeout = (ms) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };*/

  async function doProrrateoCliente(cobranzaItem) {
    //let extraInfo = {};
    let clienteId = null;
    if (cobranzaItem.cliente) {
      clienteId = cobranzaItem.cliente.id;
    } else if (cobranzaItem.cliente == null) {
      clienteId = 0;
    }

    const toastId = toast.loading("Cargando Prorrateo...");

    const response = await api
      .clienteProrrateo({
        asociadoId: asociadoId,
        clienteId: clienteId,
      })
      .catch((e) => {
        toast.error("Error al aplicar prorrateo a Asociado!", {
          id: toastId,
        });
      });
    if (!response) return;

    toast.success("Prorrateo aplicado!", {
      id: toastId,
    });

    fetchData();
  }

  async function doProrrateoAsociado() {
    /*const cobranzaItem = cobra
    const ordenParcialidades = cobranzaItem.ordenParcialidades;
    const productoParcialidades = ordenParcialidades.flatMap(
      (e) => e.productoParcialidades,
    );

    const total = productoParcialidades.map((e) => {
      return e.total;
    });

    let cobranzaAll = { ...cobranzaInfoDetail };

    productoParcialidades.forEach(async (e) => {
      const parcialidad = e.parcialidades[e.parcialidadNumero - 1];
      //const porPagar = parcialidad.porPagar;
      const porPagar = parcialidad.total;

      //
      //  cobranzaAll.disponible

      let extraInfo = {};
      if (cobranzaItem.cliente) {
        extraInfo = { clienteId: cobranzaItem.cliente.id };
      } else if (cobranzaItem.cliente == null) {
        extraInfo = { clienteId: cobranzaItem.cliente.id };
      }*/

    const toastId = toast.loading("Cargando Prorrateo...");

    setIsLoading(true);

    const response = await api
      .asociadoProrrateo({
        asociadoId: asociadoId,
      })
      .catch((e) => {
        toast.error("Error al aplicar prorrateo a Asociado!", {
          id: toastId,
        });
      });
    setIsLoading(false);

    if (!response) return;

    toast.success("Prorrateo aplicado!", {
      id: toastId,
    });

    fetchData();
  }

  const disableAgregarEntrante = !(
    asociadoId > 0 &&
    formik.values.entrante > 0 &&
    formaDePagoSelected > 0
  );

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales overflow-auto">
        <CreatePago
          ref={createPagoRef}
          {...modalPagoData}
          reloadCobranza={reloadCobranza}
        />

        <CreateConvenio
          ref={createConvenioRef}
          {...modalConvenioData}
          reloadCobranza={reloadCobranza}
        />

        <PagosModal ref={verPagosRef} item={modalPagosData} />
        <ProrrateoModal
          ref={verProrrateosRef}
          item={modalProrrateosModalData}
          reloadOrdenes={reloadCobranza}
        />

        <ChangeCreditLimitModal ref={changeCreditLimitRef} item={modalData} />

        <ChangeLevelModal ref={changeLevelRef} item={modalData} />

        <div className="">
          {/*  <CurrencyInput initialValue={0} currencySymbol="$" /> */}

          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="header">
              {/*  <SearchBar
                onChange={(e) => onChangeSearchText(e)}
                placeholder={"Buscar Asociado..."}
              /> */}
              <AutocompleteGo
                ref={refAutocompleteAsociados}
                options={asociados}
                placeholder="Buscar asociado..."
                className={`form-select ${invalidClass(errorsAsociadoId)}`}
                value={asociadoId}
                onChange={(e) => {
                  //formik.setFieldValue("sucursal", e);
                  console.log(e);
                  const id = e == null ? 0 : parseInt(e.id);
                  //  formik.setFieldValue("asociadoId", id);
                  //  asociadoIdRef.current = id;

                  //  setDisableCrearOrden(id === 0);
                  //  formik.setFieldValue("clienteId", 0);

                  //-   validateOrder();

                  // -clientFetch(id);

                  setAsociadoId(id);
                }}
                readOnly={false}
              >
                <div className="valid-feedback">Looks good!</div>
                <div className="invalid-feedback">{errorsAsociadoId}</div>
              </AutocompleteGo>
            </div>

            <div className="">
              <div className="bd-example card">
                <div className="container overflow-hidden">
                  <div className="row  gx-5">
                    <div
                      className="col card1 recent-sales overflow-auto"
                      style={{
                        backgroundColor: "transparent",
                        borderRadius: "0px",
                        marginBottom: "30px",
                      }}
                    ></div>

                    <div className="d-flex flex-row justify-content-around">
                      <div className="d-flex flex-column mb-3 align-items-center">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label fw-semibold"
                        >
                          Saldo al Corte
                        </label>

                        <LabelLoading
                          isLoading={isHeaderLoading}
                          text={cobranzaAll.saldoAlCorte}
                        />
                      </div>

                      <div className="d-flex flex-column mb-3 align-items-center">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label fw-semibold"
                        >
                          Comisión Total
                        </label>

                        <LabelLoading
                          isLoading={isHeaderLoading}
                          text={cobranzaAll.comisionTotal}
                        />
                      </div>

                      <div className="d-flex flex-column mb-3 align-items-center">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label fw-semibold"
                        >
                          Comisión Final
                        </label>
                        <LabelLoading
                          isLoading={isHeaderLoading}
                          text={cobranzaAll.comisionFinal}
                        />
                      </div>

                      <div className="d-flex flex-column mb-3 align-items-center">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label fw-semibold"
                        >
                          Total a Pagar
                        </label>
                        <LabelLoading
                          isLoading={isHeaderLoading}
                          text={cobranzaAll.totalAPagar}
                        />
                      </div>

                      <div className="d-flex flex-column mb-3 align-items-center">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label fw-semibold"
                        >
                          Abonado
                        </label>

                        <a
                          className="icon-link icon-link-hover"
                          href="#"
                          onClick={async (e) => {
                            console.log("---XXX--");
                          }}
                        >
                          <LabelLoading
                            isLoading={isHeaderLoading}
                            text={abonado}
                            onClick={(e) => {
                              verPagos(e);
                            }}
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-cash-stack"
                            viewBox="0 0 16 16"
                          >
                            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                            <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z" />
                          </svg>
                        </a>
                      </div>
                    </div>

                    {/*<div className="row">
                      <div className="border border-dark-subtle mb-4"></div>
                    </div>*/}

                    <div className="separator"></div>

                    <form
                      onSubmit={(event) => {
                        event.preventDefault();
                      }}
                    >
                      <div
                        className=""
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <div className="col-6">
                          {!isFormaPagoLoading && (
                            <>
                              <div style={{ display: "flex", gap: "10px" }}>
                                <div className="col">
                                  <div className="mb-3">
                                    <label
                                      htmlFor="formGroupExampleInput"
                                      className="form-label"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Entrante
                                    </label>
                                    <div className="input-group">
                                      <CurrencyInput
                                        initialValue={formik.values.entrante}
                                        value={formik.values.entrante}
                                        className={`form-control ${invalidClass()}`}
                                        placeholder="Cantidad a Agregar"
                                        onNewValueHandler={(p) => {
                                          //  console.log(p);
                                          formik.setFieldValue("entrante", p);
                                        }}
                                      />

                                      {/**  <input
                                      ref={withMask("currency", {
                                        groupSeparator: ",",
                                        digits: 2,
                                        numericInput: true,
                                        rightAlign: false,
                                        allowMinus: false,
                                      })}
                                      type="text"
                                      className={`form-control ${invalidClass()}`}
                                      id="validationName"
                                      aria-describedby="emailHelp"
                                      value={formik.values.entrante}
                                      placeholder="Cantidad a Agregar"
                                      onInput={async (e) => {
                                        const { selectionStart } = e.target;

                                        const aValue = onlyNumbersFloat(
                                          e.target.value,
                                        );

                                        console.log(
                                          "---> " +
                                            aValue +
                                            "  _ " +
                                            selectionStart,
                                        );
                                        formik.setFieldValue(
                                          "entrante",
                                          aValue,
                                        );

                                        // Restore cursor position in the next frame
                                        window.requestAnimationFrame(() => {
                                          e.target.selectionStart =
                                            selectionStart;
                                          e.target.selectionEnd =
                                            selectionStart;
                                        });
                                      }}
                                      disabled={false}
                                    />
                                     */}
                                    </div>
                                  </div>
                                </div>
                                <div className="col1">
                                  <label
                                    htmlFor="exampleInputEmail1"
                                    className="form-label"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Formas de Pago
                                  </label>
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={formaDePagoSelected}
                                    onChange={(item) => {
                                      const monthIndex = parseInt(
                                        item.currentTarget.value,
                                      );
                                      setFormaDePagoSelected(monthIndex);
                                      //fetchData(monthIndex, yearSelected);
                                    }}
                                  >
                                    {formasDePago.map((item, index) => {
                                      return (
                                        <option
                                          selected={item.isSelected}
                                          value={item.id}
                                          disabled={item.id === 0}
                                          hidden={item.id === 0}
                                        >
                                          {item.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <div className="valid-feedback"></div>
                                  <div className="invalid-feedback"></div>
                                </div>

                                <div className="col d-flex align-items-center">
                                  <LoadingButton
                                    style={{ height: "38px" }}
                                    onClick={(e) => saveAmount(e)}
                                    text={"Agregar"}
                                    loadingText={"Agregando..."}
                                    isLoading={isHeaderLoading}
                                    isDisable={disableAgregarEntrante}
                                  />
                                </div>
                              </div>

                              <div className="col-1 d-flex">
                                <div className="border border-primary"></div>
                              </div>
                            </>
                          )}

                          {isFormaPagoLoading && (
                            <div
                              className="animate-pulse"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  height: "83px",
                                  width: "300px",
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="card col d-flex justify-content-center align-items-center">
                          <div className="">
                            <div className="">
                              <label
                                htmlFor="formGroupExampleInput"
                                className="fw-bold"
                              >
                                Disponible:
                              </label>
                              <LabelLoading
                                text={cobranzaInfoDetailAll.disponible}
                                isLoading={isHeaderLoading}
                                moreClass={"ms-1"}
                              />
                            </div>

                            <div
                              className=""
                              style={{ display: "flex", gap: "10px" }}
                            >
                              <LoadingButton
                                style={{ height: "38px" }}
                                onClick={async (e) => {
                                  doProrrateoAsociado();
                                }}
                                text={"Prorratear"}
                                loadingText={"Prorrateando..."}
                                isLoading={isLoading}
                                isDisable={true}
                              />

                              <button
                                type="button"
                                className={`${buttonStyles.link_button} icon-link icon-link-hover d-flex text-primary`}
                                onClick={async (e) => {
                                  console.log("---XXX--");
                                  verProrrateosAnteriores(e);
                                }}
                              >
                                Ver
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-cash-stack"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                  <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>

                    {/**   <div
                      className="col card1 recent-sales overflow-auto"
                      style={{
                        backgroundColor: "transparent",
                        borderRadius: "0px",
                        marginBottom: "30px",
                      }}
                    ></div> */}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginRight: "40px" }}
                disabled={isLoading}
                hidden={true}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button
                className="btn btn-primary"
                onClick={createAsociado}
                hidden={true}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Asociado
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            ></div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
          hidden={true}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item, index) => {
              let page = pagingInfoRef.current.pageNumber();
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  key={index}
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>
        {/** */}
        <div className="card-body">
          <CobranzaReestructuraTable
            items={kpiData}
            lastParcialInfo={lastParcialInfo}
            cobranzaInfoDetail={cobranzaInfoDetail}
            openItem={loadItem}
            openConvenio={createConvenios}
            handleDetail={detailItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
            openEstadoCuenta={openEstadoCuenta}
            abonarCliente={abonarCliente}
            abonarProducto={abonarProducto}
          />
        </div>
      </div>
    </>
  );
}
